<template>
  <sliding-window>
    <div class="ProjectFichePanel" slot="panel" v-if="p.uuid">
      <violet-bar>Options</violet-bar>
      <div class="squarebox">
        <vertical-field>
          <label for="" class="label" slot="label">Format de page :</label>
          <div class="field">
            <label class="radio is-small"
              >A4
              <input type="radio" value="A4" name="format" v-model="pm.format"
            /></label>
            <label class="radio is-small"
              >A3
              <input type="radio" value="A3" name="format" v-model="pm.format"
            /></label>
          </div>
        </vertical-field>
      </div>
      <violet-bar>Contenus</violet-bar>
      <div class="squarebox">
        <vertical-field v-if="pm.format === 'A3'">
          <label slot="label" class="label">Axe :</label>
          <div class="select is-small">
            <select @change="handleAxeChange" v-if="p.contents_d.length > 0">
              <option value="-1" disabled>Choisissez l'axe</option>
              <option
                :value="d.axe_id"
                v-for="d in p.contents_d"
                :key="d.axe_id"
                >{{ d.name }}</option
              >
            </select>
          </div>
        </vertical-field>
        <label class="label">Images générales :</label>
        <div class="squarebox" style="display: flex; flex-wrap: wrap;">
          <div
            v-for="i in availablePictures(1)"
            :key="i.picture.id"
            style="position:relative; width:100px; padding: 4px;"
          >
            <input
              type="checkbox"
              class="checkbox"
              style="position:absolute; z-index: 1"
              :checked="pm.gen_image === i.picture.id"
              @change="handleImageSelect('gen_image', i.picture.id)"
            />
            <ratio-cropper
              :picture-id="i.picture.id"
              :ratio="1"
            ></ratio-cropper>
          </div>
        </div>
        <div class="field" v-if="format === 'A3'">
          <label class="label">Images thématiques disponibles :</label>
          <div class="squarebox" style="display: flex; flex-wrap: wrap;">
            <div
              v-for="i in availablePictures(pm.axe)"
              :key="i.picture.id"
              style="position:relative; width:100px; padding: 4px;"
            >
              <input
                type="checkbox"
                class="checkbox"
                style="position:absolute; z-index: 1"
                :checked="pm.axe_image === i.picture.id"
                @change="handleImageSelect('axe_image', i.picture.id)"
              />
              <ratio-cropper
                :picture-id="i.picture.id"
                :ratio="1"
              ></ratio-cropper>
            </div>
          </div>
        </div>
      </div>
      <violet-bar> Impression et téléchargement </violet-bar>
      <div class="squarebox">
        <div class="field">
          <div class="control">
            <button
              class="button is-info"
              @click="print"
              :class="loading ? 'is-loading' : ''"
            >
              <i class="fa fa-print"></i>&nbsp;Générer le .PDF
            </button>
          </div>
        </div>
        <div class="control" v-if="render">
          <div class="RenderPreview">
            <img
              class="RenderPreview__img"
              :src="render.thumbnail.public_path"
            />
          </div>
          <a class="button is-info" :href="render.friendly_path" target="_blank"
            ><i class="fa fa-cloud-download-alt"></i>&nbsp;Télécharger</a
          >
          <a class="button is-primary" v-if="format === 'A3' && pm.axe === 1" @click.prevent="set_canonical(render)">Définir comme fiche du projet</a>
        </div>
      </div>
      <div class="control">
        <button class="button" :to="'/home'">
          <i class="fa fa-arrow-left"></i>&nbsp;retour
        </button>
      </div>
    </div>
    <page-format-handler v-if="p.uuid" :format="pm.format">
      <page :format="pm.format">
        <component
          :is="
            pm.format === 'A4'
              ? $options.components.FichePortrait
              : $options.components.FichePaysage
          "
          :format="pm.format"
          :p="p"
          :pm="pm"
        />
      </page>
    </page-format-handler>
  </sliding-window>
</template>

<script>
import { types as t } from "../../../../store/actions/projects";
import { DRAWING_SPACE_MOVED } from "../../../../util/func";
import PageFormatHandler from "../../PrintComponents/Page/PageFormatHandler";
import SlidingWindow from "../../PrintComponents/Workspace/SlidingWindow";
import RatioCropper from "../../../../components/Layout/ApiPictureCropped";
import FichePortrait from "./A4/FichePortrait";
import FichePaysage from "./A3/FichePaysage";
import Page from "../../PrintComponents/Page/Page";
import { types } from "../../../../store/actions/render";
import { get, rem } from "../../../../storage/storage";
import VioletBar from "../../../Projects/VioletBar";
import HorizField from "../../../../components/Form/HorizField";
import VerticalField from "../../../../components/Form/VerticalField";

export default {
  name: "FicheProjet",
  components: {
    VerticalField,
    HorizField,
    VioletBar,
    Page,
    RatioCropper,
    SlidingWindow,
    PageFormatHandler,
    FichePortrait,
    FichePaysage
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      p: {},
      pm: {
        date: -1,
        axe: 1,
        map: -1,
        gen_image: 0,
        axe_image: 0,
        format: "A4"
      },
      loading: false,
      bar: 0.5,
      drag: false,
      render: null
    };
  },
  computed: {
    hasProject() {
      return !!this.p.uuid;
    },
    format() {
      return this.pm.format;
    }
  },
  methods: {
    availablePictures(axe) {
      if (!this.hasProject) return [];
      const a = this.p.contents_d.find(a => a.axe_id === (axe || this.pm.axe));
      return a ? a.pictures.filter(c => c.picture) : [];
    },
    moveCursor(e) {
      if (!this.drag) return;
      const w = window.innerWidth;
      this.bar = e.pageX / w;
      this.$root.$emit(DRAWING_SPACE_MOVED);
    },
    handleImageSelect(key, id) {
      this.pm[key] = id;
    },
    handleAxeChange(e) {
      this.pm.axe = parseInt(e.target.value, 10);
      this.pm.axe_image = 0;
      this.setBasePicture();
      this.setBaseAxePicture();
    },
    setBaseAxe() {
      const p = this.p.contents_d;
      this.pm.axe = p.length > 0 ? parseInt(p[0].axe_id, 10) : 1;
    },
    setBasePicture() {
      const p = this.availablePictures(1);
      this.pm.gen_image = p.length > 0 ? p[0].picture.id : [];
    },
    setBaseAxePicture() {
      const p = this.availablePictures(this.pm.axe);
      this.pm.axe_image = p.length > 0 ? p[0].picture.id : [];
    },
    setBaseDate() {
      const p = this.p.dates_d;
      this.pm.date = p.length > 0 ? parseInt(p[0].date_id, 10) : -1;
    },
    async print() {
      this.loading = true;
      await new Promise(r => setTimeout(r, 500));
      const render = await this.$store.dispatch(types.EXPORT_A4_PROJECT, {
        payload: JSON.stringify(this.$data),
        url: window.location.href,
        id: this.p.id,
        friendly_name: `${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}-fiche-${
          this.pm.format
        }-${this.p.name}-.pdf`.replace(/(\s|\/|:)/gi, "-")
      });
      this.render = render;
      this.loading = false;
    },
    async set_canonical(render) {
      this.loading = 1;
      await this.$store.dispatch(t.SET_CANONICAL_PDF, {
        ...this.p,
        canonical_pdf: render.pdf,
      });
      this.loading = 0;
    },
    printManual() {
      window.print();
    }
  },
  async mounted() {
    if (window.HEADLESS) {
      this.$store
        .dispatch(types.GET_RENDERING_PAYLOAD, get("payload"))
        .then(d => {
          for (let prop in d) {
            this.$set(this, prop, d[prop]);
          }
          rem("payload");
        });
    } else {
      rem("payload");
      this.p = await this.$store.dispatch(t.GET_PROJECT_BY_UUID_D, {
        uuid: this.uuid
      });
      this.$nextTick(() => {
        this.setBaseAxe();
        this.setBasePicture();
        this.setBaseAxePicture();
        this.setBaseDate();
      });
    }
  },
  watch: {
    format: {
      async handler(val, old) {
        if (get("payload") || window.HEADLESS) return;
        if (val === "A4" && val !== old) {
          this.pm.axe = 1;
          this.setBasePicture();
        } else if (val === "A3" && val !== old) {
          await new Promise(r => this.$nextTick(r));
          const potentialAxe = this.p.contents_d.find(a => a && 1);
          this.$set(this.pm, "axe", potentialAxe ? potentialAxe.axe_id : 1);
          this.setBasePicture();
          this.setBaseAxePicture();
        }
      }
    }
  }
};
</script>
